import { baseApi } from './baseApi';

export const procedureCatalogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listProcedureCatalog: build.query({
      query: (activeOnly) => `/procedure-catalog${activeOnly ? '?activeOnly=true' : ''}`,
      transformResponse: (resp) => resp.data,
      providesTags: (result) => [
        { type: 'ProcedureCatalog', id: 'LIST' },
        ...(result?.map((p) => ({ type: 'ProcedureCatalog', id: p.id })) ?? []),
      ],
    }),
    createProcedureCatalogItem: build.mutation({
      query: (body) => ({ url: '/procedure-catalog', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: [{ type: 'ProcedureCatalog', id: 'LIST' }],
    }),
    updateProcedureCatalogItem: build.mutation({
      query: ({ id, ...body }) => ({ url: `/procedure-catalog/${id}`, method: 'PUT', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'ProcedureCatalog', id },
        { type: 'ProcedureCatalog', id: 'LIST' },
      ],
    }),
    deleteProcedureCatalogItem: build.mutation({
      query: (id) => ({ url: `/procedure-catalog/${id}`, method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'ProcedureCatalog', id },
        { type: 'ProcedureCatalog', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useListProcedureCatalogQuery,
  useCreateProcedureCatalogItemMutation,
  useUpdateProcedureCatalogItemMutation,
  useDeleteProcedureCatalogItemMutation,
} = procedureCatalogApi;
